// Normalized customer_type → interactive report mode.
export const CUSTOMER_TYPE_MODE_MAP = {
  primary_care: "Safety",
  pcp: "Safety",
  primarycare: "Safety",
  safety: "Safety",
  senior_living: "senior_living",
  sl: "senior_living",
  seniorliving: "senior_living",
  home_care: "home_care",
  hc: "home_care",
  homecare: "home_care",
  pharmacy: "pharmacy",
  fp: "pharmacy",
  familiprix: "pharmacy",
  rehab: "rehab",
  longevity: "Longevity",
};

export const resolveMobilityMode = (user) => {
  const raw =
    user?.customer_type ||
    user?.customerType ||
    user?.tenant_type ||
    user?.tenantType ||
    user?.careSetting ||
    user?.tenant ||
    "";
  const normalized = String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  return CUSTOMER_TYPE_MODE_MAP[normalized] || "Safety";
};
